import localforage from "localforage";
// async function init_db() {
const dbName = 'ayalon_db';
let db = null;

class OfflineStorage {

    constructor() {
        if (!db) {
            db = localforage.createInstance({
                name: dbName
            })
        }
    }
    getItem(key){
        return db.getItem(key);
    }

    setItem(key, value) {
        db.setItem(key, value).then(function () {
            return db.getItem(key);
        }).catch(function (err) {
            console.log(err);
            // we got an error
        });
    }


/*
    const getKeyVal = {
        async get(key) {
            return (await db).get('questionaire', key);
        },
        async set(key, val) {
            return (await db).put('questionaire', val, key);
        },
        async delete(key) {
            return (await db).delete('questionaire', key);
        },
        async clear() {
            return (await db).clear('questionaire');
        },
        async keys() {
            return (await db).getAllKeys('questionaire');
        },
    };
*/
}
const offlineStorage = new OfflineStorage();

export default offlineStorage
// }